import Operadores from '../Usuarios/Operador';

// Menu "Clientes": a mesma tela de Cambistas, listando só os operadores com
// tipo_usuario = cliente.
export default function Clientes(props) {
    return <Operadores {...props} tipoUsuario="cliente" />;
}
